import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { Menu, Text } from '@poliedro/tamentai';

import { routesConfig } from '../../routes/routesConfig';
import { RootState } from '../../store';
import { AllowedProfiles } from '../../utils/AllowedProfiles';
import { isEducationChildhoodProfile } from '../../utils/isEducationChildhoodProfile';

const NavBar = () => {
  const location = useLocation();
  const profile = useSelector((state: RootState) => state.profile.profileData);
  const { items: features, loading: isLoadingFeatures } = useSelector(
    (state: RootState) => state.features,
  );

  const shouldBlockEducationChildhoodFeatures = isEducationChildhoodProfile(profile);

  const isStudent = AllowedProfiles(profile?.perfil?.nome, ['Aluno']);

  const currentUserProfiles: string[] = [];
  if (isStudent) {
    currentUserProfiles.push('student');
  }
  if (shouldBlockEducationChildhoodFeatures) {
    currentUserProfiles.push('education_childhood');
  }

  const hasFeature = (featureName: string | undefined) => {
    if (!featureName) return true;
    return features.some(feature => feature.feature_group === featureName);
  };

  const visibleRoutes = routesConfig.filter(route => {
    if (!route.showInNavBar) {
      return false;
    }

    const isBlocked =
      route.blockedForProfiles?.some(profile =>
        currentUserProfiles.includes(profile),
      ) ?? false;

    if (isBlocked) {
      return false;
    }

    if (isLoadingFeatures && route.feature) {
      return false;
    }

    if (!hasFeature(route.feature)) {
      return false;
    }

    return true;
  });

  const isRouteActive = (routePath: string) => {
    const { pathname, search } = location;
    const currentPath = `${pathname}${search}`;
    return currentPath === routePath;
  };

  return (
    <Menu.Root>
      {visibleRoutes.map(route => (
        <NavLink to={route.path} key={route.path}>
          <Menu.Item active={isRouteActive(route.path)}>
            {route.icon}
            <Text variant="label-lg">{route.label}</Text>
          </Menu.Item>
        </NavLink>
      ))}
    </Menu.Root>
  );
};

export default NavBar;
